import React, { Component } from 'react'
import api from '~base/api'
import queryString from 'query-string'

import Page from '~base/page'
import {loggedIn} from '~base/middlewares/'

import { Redirect } from 'react-router-dom'

import {BaseForm, TextWidget} from '~components/base-form'

const schema = {
  type: 'object',
  required: ['url', 'title'],
  properties: {
    url: {type: 'string', title: 'Url'},
    title: {type: 'string', title: 'Titulo'}
  }
}

const uiSchema = {
  url: { 'ui:widget': TextWidget },
  title: { 'ui:widget': TextWidget }
}

class PostCreate extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      initialState: {
        url: queryString.parse(props.location.search).u,
        title: queryString.parse(props.location.search).t
      }
    }
  }

  componentWillMount () {}

  async submitHandler ({formData}) {
    if (this.state.loading) { return }

    this.setState({loading: true})

    var data
    try {
      data = await api.post('/comparte/posts', formData)
    } catch (e) {
      this.setState({error: e.message, loading: false})
    }

    this.setState({
      redirectToPost: data.uuid,
      loading: false
    })
  }

  render () {
    if (this.state.redirectToPost) {
      return <Redirect to={`/posts/${this.state.redirectToPost}`} />
    }

    var loadingElem
    if (this.state.loading) {
      loadingElem = <button className='button is-primary is-fullwidth is-loading' type='submit'>Please be patiente</button>
    } else {
      loadingElem = <button className='button is-primary is-fullwidth' type='submit'>Crear</button>
    }

    return (
      <div className='App container' style={{marginTop: 40, marginBottom: 100}}>
        <div className='card-content'>
          <div className='content'>
            <BaseForm schema={schema}
              formData={this.state.initialState}
              uiSchema={uiSchema}
              onSubmit={(e) => { this.submitHandler(e) }}
              onError={(e) => { this.errorHandler(e) }}>
              <div>
                {loadingElem}
              </div>
            </BaseForm>
          </div>
        </div>
      </div>
    )
  }
}

export default Page({
  path: '/post',
  title: 'Agregar contenido',
  exact: true,
  validate: loggedIn,
  component: PostCreate
})



// WEBPACK FOOTER //
// ../frontend/pages/post/create.js